
import { FC } from "react";
import { headerPorps } from "./types";
import { COVERAGE_AVAILABLE } from "src/constants/todos";
import GenericTableHeader from "./genericActionDashbaordHeader";

const CoverageTableHeader: FC<headerPorps> = ({ queryParam, changeIdOrder }) => {
  return (
      <GenericTableHeader queryParam={queryParam} changeIdOrder={changeIdOrder} tableHeader={COVERAGE_AVAILABLE} />
  );
};

         

export default CoverageTableHeader;
